// src/pages/auth/NewPassword.js
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from "react-router-dom";
import { useMainPageTitle } from "../../contexts/PageContext";
import PasswordInput from "../../components/form/passwordInput";

const API_URL = "https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1";
const NewPassword = () => {
  const { t } = useTranslation();
  const { updatePageTitle } = useMainPageTitle();
  useEffect(() => {
    updatePageTitle(t("labels.newPassword"), t("labels.newPassword"));
  }, [updatePageTitle, t]);
  const { state } = useLocation();
  const { email, token } = state || {};
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const validatePassword = (password) => {
    // Password must be at least 8 characters, include uppercase, lowercase, number, and special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validate passwords
    if (!password || !confirmPassword) {
      setError("Please fill in all fields");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters and include uppercase, lowercase, number, and special character"
      );
      return;
    }

    try {
      // Send request to reset password
      const response = await fetch(`${API_URL}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
          email,
          password: password,
        }),
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.errors || data.message || "Failed to reset password");
      }

      setSuccess(true);

      console.log(data);

      // Redirect to login page after 3 seconds
      setTimeout(() => {
        localStorage.clear();
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("firstName", data.user.firstName);
        localStorage.setItem("lastName", data.user.lastName);
        localStorage.setItem("userName", data.user.userName);
        localStorage.setItem("email", data.user.email);
        localStorage.setItem("phone", data.user.phone);
        localStorage.setItem("profilePicture", data.user.profilePicture);
        localStorage.setItem("userType", data.user.userType);
        localStorage.setItem("token", data.token);
        navigate("/user/profile");
      }, 3000);
    } catch (err) {
      setError(err.message || "An error occurred. Please try again.");
    }
  };

  return (
    <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Set New Password
          </h2>
        </div>

        {error && (
          <div className="rounded-md bg-red-50 p-4 mb-4">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-800">{error}</h3>
              </div>
            </div>
          </div>
        )}

        {success ? (
          <div className="rounded-md bg-green-50 p-4">
            <div className="flex">
              <div className="ml-3">
                <h3 className="text-sm font-medium text-green-800">
                  Password has been reset successfully! Redirecting to login
                  page...
                </h3>
              </div>
            </div>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="-space-y-px rounded-md shadow-sm">
              <PasswordInput
                placeholder="Ex : **********"
                label={t("auth.password")}
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                required
                error={error}
              />
              <PasswordInput
                placeholder="Ex : **********"
                label="Confirm Password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
                required
                error={error}
              />

              <div className="flex justify-center mt-10 pt-5">
                <button
                  type="submit"
                  className="btn
      bg-[#F15213] text-white rounded-md p-2 w-full h-[60px] text-lg
      font-bold hover:bg-[#F15213]/80 transition-all duration-300 shadow-md hover:shadow-lg hover:scale-105 hover:cursor-pointer mt-5"
                >
                  Reset Password
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default NewPassword;
